const routes = [
  {
    index: true,
    label: 'Pablo Hernandez Borges',
    path: '/',
  },
  {
    label: 'About',
    path: '/about',
  },
  {
    label: 'Resume',
    path: '/resume',
  },
  {
    label: 'Projects',
    path: '/projects',
  },
  {
    label: 'Posters',
    path: '/posters',
  },
  {
    label: 'Maps',
    path: '/maps',
  },
  {
    label: 'Contact',
    path: '/contact',
  },
];

export default routes;
